import React, { memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import { MenuIcon, CloseIcon } from '../icons';
import palette from '../styles/palette';
import layoutStyles from '../styles/layout';

const useStyles = makeStyles(() => ({
  headerContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    transition: 'top .2s',
    zIndex: 2,
  },
  headerHidden: {
    top: `-${layoutStyles.header.height}px`,
  },
  toggleButton: {
    position: 'absolute',
    right: '27px',
    width: '34px',
    height: '20px',
    // backgroundColor: palette.white,
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
    '& svg': {
      width: '16px',
      height: '16px',
    },
  },
  header: {
    borderBottom: `1px solid ${palette.grey[200]}`,
    position: 'relative',
  },
  closeIcon: {
    fillOpacity: 0.7,
  },
  toggle: {
    backgroundColor: palette.slate,
    boxShadow: '0 4px 4px rgba(0, 0, 0, 0.25)',
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,

    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    cursor: 'pointer',
  },
  toggleIcon: {
    borderTop: `solid ${2}px ${palette.white}`,
    borderBottom: `solid ${2}px ${palette.white}`,
    height: 6,
    width: 24,
    marginTop: 5,
    marginBottom: 6,
    marginLeft: 8,
    marginRight: 8,
  },
}));

const Header = ({
  headerContent,
  subheaderContent,
  isHeaderVisible,
  setIsHeaderVisible,
}) => {
  const styles = useStyles();

  const handleToggleHeader = () => {
    setIsHeaderVisible((prev) => !prev);
  };

  return (
    <Box
      className={clsx(
        styles.headerContainer,
        !isHeaderVisible && styles.headerHidden
      )}
    >
      <Box className={styles.header}>{headerContent}</Box>
      <Box className={clsx(styles.subheader)}>{subheaderContent}</Box>
      <div className={styles.toggle} onClick={handleToggleHeader}>
        <div className={styles.toggleIcon} />
      </div>
      {/* <Box
        className={styles.toggleButton}
        onClick={handleToggleHeader}
        data-testid="toggle-header"
        aria-expanded={isHeaderVisible}
        aria-label={isHeaderVisible ? 'Hide header' : 'Show header'}
      >
        {isHeaderVisible ? (
          <CloseIcon className={styles.closeIcon} />
        ) : (
          <MenuIcon />
        )}
      </Box> */}
    </Box>
  );
};

export default memo(Header);
